import React, { useEffect, useState } from "react";
import "./project.css"; // Ensure you have correct styles

function Counter({ target }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = target / 100; // Smooth increment
    const interval = setInterval(() => {
      start += increment;
      if (start >= target) {
        clearInterval(interval);
        setCount(target);
      } else {
        setCount(Math.floor(start));
      }
    }, 20); // Adjust speed
    return () => clearInterval(interval);
  }, [target]);

  return <span className="counter">{count}</span>;
}

function Project() {
  return (
    <div className="fact-counter-wrapper padding ptb-xs-40">
      <div className="container text-center">
        <div className="row">
          <div className="col-lg-3 col-md-6 mb-sm-30 mb-xs-30">
            <div className="single-fact">
              <div className="icon-boxed">
                <i className="ion-ios-list"></i>
              </div>
              <Counter target={205} />
              <p>Total Projects</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 mb-sm-30 mb-xs-30">
            <div className="single-fact">
              <div className="icon-boxed">
                <i className="ion-happy"></i>
              </div>
              <Counter target={162} />
              <p>Happy Clients</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 mb-xs-30">
            <div className="single-fact">
              <div className="icon-boxed">
                <i className="ion-person-stalker"></i>
              </div>
              <Counter target={84} />
              <p>Active Members</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="single-fact">
              <div className="icon-boxed">
                <i className="ion-trophy"></i>
              </div>
              <Counter target={10} />
              <p>Won Awards</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Project;
